import React, { useEffect } from "react";
import { Link } from "react-router-dom";

// Soro blog embed — third-party widget. Loads on every mount, cleans up on unmount.
// Soro injects content into the #soro-blog div via its own script.
const SORO_EMBED_SRC = "https://app.trysoro.com/api/embed/29b2df3a-6b94-4ab7-a81c-7e8be7c5501a";

export default function Blog() {
  useEffect(() => {
    document.title = "Blog — CALIBRATE | Insights on performance calibration";

    // Inject the Soro embed script. Skip if already loaded by a previous mount.
    const existing = document.querySelector(`script[src="${SORO_EMBED_SRC}"]`);
    if (existing) {
      // Force the third-party script to re-render into the container when the
      // user navigates back via client-side routing.
      try { existing.remove(); } catch (_) { /* ignore */ }
    }
    const s = document.createElement("script");
    s.src = SORO_EMBED_SRC;
    s.defer = true;
    s.async = true;
    document.body.appendChild(s);

    return () => {
      try { s.remove(); } catch (_) { /* ignore */ }
    };
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="blog-page">
      <div className="font-mono-cal text-[11px] uppercase tracking-[0.2em] text-[#666] mb-4">
        [ BLOG ]
      </div>
      <h1 className="font-display font-bold text-5xl sm:text-6xl tracking-tight mb-4">
        From the CALIBRATE blog
      </h1>
      <p className="text-[#666] text-lg leading-relaxed mb-12 max-w-2xl">
        Practical writing on performance reviews, calibration, and removing bias from people decisions.
      </p>

      {/* Soro blog widget injects its content into this div */}
      <div id="soro-blog" data-testid="soro-blog-mount" className="cal-prose" />

      <footer className="mt-20 pt-8 border-t border-[#111]/10 text-xs font-mono-cal text-[#666] flex flex-wrap gap-5">
        <Link to="/" className="hover:text-[#FF4F00]" data-testid="blog-back-home">← Home</Link>
        <Link to="/pricing" className="hover:text-[#FF4F00]">Pricing</Link>
        <Link to="/faq" className="hover:text-[#FF4F00]">FAQ</Link>
        <Link to="/terms" className="hover:text-[#FF4F00]">Terms</Link>
        <a href="mailto:support@calibrate.management" className="hover:text-[#FF4F00]">Contact</a>
      </footer>
    </div>
  );
}
